import React from 'react';
import { useIntl } from 'react-intl';

import { ModalLayout } from '@/features/modal/modals/ModalLayout';
import { Button } from '@/components/buttons/Button';
import { TranslatedRichText } from '@/components/TranslatedRichText';
import { BaseModalProps } from '@/features/modal/types';
import { GTagEvents, triggerGTag } from '@/lib/gTagManager';
import { getAlbertaRedirectUrl, redirectToExternalSite } from '@/utils/alberta-redirect';

export const AlbertaLoginMigrationModal = ({ closeModal }: BaseModalProps): JSX.Element => {
  const intl = useIntl();
  const redirectUrl = getAlbertaRedirectUrl('roc', true, true);

  const onGo = (e: React.MouseEvent<HTMLAnchorElement>) => {
    triggerGTag(GTagEvents.alberta_migrate_cta);
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
      return; // let the browser handle modifier/middle clicks natively
    }
    e.preventDefault();
    redirectToExternalSite(redirectUrl);
  };

  return (
    <ModalLayout data-testid="alberta-login-migration-modal" close={closeModal}>
      <div className="w-full text-center grid grid-cols-1 gap-6">
        <h1 className="text-xl font-bold">
          {intl.formatMessage({ id: 'alberta.login.migration.header' })}
        </h1>
        <TranslatedRichText id="alberta.login.migration.text" tagName="div" />
        <a
          href={redirectUrl}
          onClick={onGo}
          className="relative w-full rounded-3xl p-3 bg-blue-light hover:bg-cyan-600 text-white text-md text-center font-bold leading-6 transition"
        >
          {intl.formatMessage({ id: 'alberta.login.migration.cta.go' })}
        </a>
        <Button
          onClickHandler={() => closeModal()}
          btnType="outline"
          text={intl.formatMessage({ id: 'alberta.login.migration.cta.view' })}
        />
      </div>
    </ModalLayout>
  );
};
